/* eslint-disable */
import store from "../../store/index";
import axios from "axios";

export default {
  name: "EditStudyPopUp",
  props: {
    studyid: String,
    versiondetails: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      selectedstudy: "",
      classficationList: [],
      isSaving: false,
      selectedStudyType: "",
      enrolment: "",
      allocation: "",
      intervention: "",
      masking: "",
      purpose: "",
      title: "",
      values: {
        accountId: "",
        folderId: "",
        studyRef: "",
        studyName: "",
        sponsor: "",
        status: "New",
        studyId: "",
        studyNotes: "",
        preVisit: "",
        postVisit: "",
        numberOfSite: "",
        numberOfPatient: "",
        duration: 0,
        active: true,
        isArmSpecific: false,
        isDeleted: false,
        studyProperties: [],
        oldVersion: "",
        newVersion: "",
        regulatoryRef: "",
        changeType: "",
        reasonForChange: "",
        reqReConsent: false
      },
      numerrors: {
        preVisit: true,
        postVisit: true,
        numberOfSite: true,
        numberOfPatient: true,
        duration: true
      },
      validations: [false, false],
      errors: []
    };
  },

  mounted() {
    this.values.studyRef = this.versiondetails.studyRef;
    this.values.studyName = this.versiondetails.studyName;
    this.values.sponsor = this.versiondetails.sponsor;
    this.values.oldVersion = this.versiondetails.currentVersion;
    this.selectedstudy = this.studyid;
    this.retrieveinfo();
    this.getClassfications();
  },

  methods: {
    async getClassfications() {
      const idtoken = store.getters.getIdToken;
      try {
        const res = await axios.get(`${this.baseurl}/management/study/getstudyclassifications`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json"
          }
        });
        const data = Array.isArray(res.data) ? res.data : res.data.classifications || [];

        data.forEach(item => {
          if (Array.isArray(item.classifications)) {
            item.classifications.sort((a, b) =>
              a.toString().localeCompare(b.toString(), undefined, { sensitivity: 'base' })
            );
          }
        });
        this.classficationList = data;
      } catch (err) {
        console.error("Error loading classifications", err);
      }
    },

    async numberonlyvalidation(fieldname) {
      let isNumber = true;
      this.values[fieldname] = this.values[fieldname] ? this.values[fieldname].toString().replace(/\s/g, '') : "";
      let fieldval = this.values[fieldname];
      if (fieldval % 1 !== 0 || isNaN(fieldval)) {
        isNumber = false;
      }
      if (!isNumber || parseInt(this.values[fieldname]) < 0) {
        this.values[fieldname] = 0;
        this.numerrors[fieldname] = false;
      } else {
        this.numerrors[fieldname] = true;
      }
    },

    async validate() {
      this.values.studyName = this.values.studyName ? this.values.studyName.replace(/ +/g, ' ').trim() : "";
      this.values.sponsor = this.values.sponsor ? this.values.sponsor.replace(/ +/g, ' ').trim() : "";
      this.values.studyNotes = this.values.studyNotes ? this.values.studyNotes.replace(/ +/g, ' ').trim() : "";
      this.values.studyRef = this.values.studyRef ? this.values.studyRef.replace(/ +/g, ' ').trim() : "";

      this.validations[0] = this.values.studyName !== "";
      this.validations[1] = this.values.studyRef !== "";
    },

    generateDescription() {
      this.values.studyProperties = [
        `Study Type: ${this.selectedStudyType}`,
        `Estimated Enrollment: ${this.enrolment}`,
        `Allocation: ${this.allocation}`,
        `Intervention Model: ${this.intervention}`,
        `Masking: ${this.masking}`,
        `Primary Purpose: ${this.purpose}`,
        `Official Title: ${this.title}`
      ];
    },

    mapToCreateVersionPayload() {
      return {
        studyId: this.values.studyId,
        studyRef: this.values.studyRef,
        oldVersion: this.values.oldVersion,
        newVersion: this.values.newVersion,
        folderId: this.values.folderId,
        studyName: this.values.studyName,
        sponsor: this.values.sponsor,
        studyNotes: this.values.studyNotes,
        preVisit: Number(this.values.preVisit) || 0,
        postVisit: Number(this.values.postVisit) || 0,
        numberOfSite: Number(this.values.numberOfSite) || 0,
        numberOfPatient: Number(this.values.numberOfPatient) || 0,
        duration: Number(this.values.duration) || 0,
        studyProperties: this.values.studyProperties || [],
        version: {
          version: this.values.newVersion,
          reasonForChange: this.values.reasonForChange,
          regulatoryRef: this.values.regulatoryRef,
          changeType: this.values.changeType,
          reqReConsent: this.values.reqReConsent,
          isActive: this.values.active,
          isArmSpecific: this.values.isArmSpecific,
          approval: []
        }
      };
    },

    mapFromApiResponse(data) {
      if (!data) return;

      if (data.currentVersion) {
        this.values.oldVersion = data.currentVersion;
      } else if (data.version && data.version.version) {
        this.values.oldVersion = data.version.version;
      }

      // If API returns a nested `version` object use that, otherwise check versions array
      let versionObj = null;
      if (data.version) {
        versionObj = data.version;
      } else if (Array.isArray(data.versions)) {
        const current = data.currentVersion || this.values.oldVersion;
        versionObj = data.versions.find(v => v.version === current) || null;
      }

      if (versionObj) {
        this.values.regulatoryRef = versionObj.regulatoryRef || "";
        this.values.changeType = versionObj.changeType || "";
        this.values.reasonForChange = versionObj.reasonForChange || "";
        this.values.reqReConsent = !!versionObj.reqReConsent;
      } else {
        this.values.regulatoryRef = "";
        this.values.changeType = "";
        this.values.reasonForChange = "";
        this.values.reqReConsent = false;
      }

      // Ensure newVersion is blank by default when loading existing study for creating new version
      this.values.newVersion = "";
    },

    async saveCreateVersion() {
      this.generateDescription();
      await this.validate();

      if (this.validations.includes(false)) {
        this.errors = this.validations;
        return;
      }
      const idtoken = store.getters.getIdToken;
      try {
        this.isSaving = true;
        const payload = this.mapToCreateVersionPayload();
        await axios.post(
          `${this.baseurl}/management/study/createnewversion`,
          payload,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json"
            }
          }
        );

        alert(this.$t("navigations.version created successfully"));
        this.isSaving = false;
        this.$router.push(`/reviewStudyVersion`);

      } catch (err) {
        this.isSaving = false;
        console.log("version", this.values.newVersion);
        console.log("eroorrrrrrrrrrrrrrrrrrrrrrrrrrr", err.response?.data.messages[0]);
        if (err.response?.data.messages[0].includes(`Study ID with version ${this.values.newVersion} already exists`)) {
          alert(this.$t('navigations.version already exist'));
        }
        else {
          alert(this.$t('navigations.something went wrong'));
          this.isSaving = false;
        }
      }
    },

    async edit() {
      this.generateDescription();
      await this.validate();
      if (this.validations.includes(false)) {
        this.errors = this.validations;
        return;
      }

      const idtoken = store.getters.getIdToken;
      try {
        await axios.put(
          `${this.baseurl}/management/study/update?api-version=1.0`,
          this.values,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json"
            }
          }
        );
        alert(this.$t("navigations.study updated successfully"));
        this.$emit("studyChanged");
        this.$emit("closeModal");
      } catch (err) {
        alert(err.response?.data?.detail || "Update failed");
      }
    },

    async retrieveinfo() {
      const idtoken = store.getters.getIdToken;
      if (!this.selectedstudy || this.selectedstudy === "0") return;
      try {
        const response = await axios.get(
          `${this.baseurl}/management/study/getbyid?id=${this.selectedstudy}&version=${this.values.oldVersion}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json"
            }
          }
        );
        const data = response.data;
        this.values = {
          ...this.values,
          ...data,
          oldVersion: data.currentVersion || "",
          newVersion: "",
          regulatoryRef: "",
          changeType: "",
          reasonForChange: "",
          reqReConsent: false
        };

        if (data.studyName) this.title = data.studyName;

        const props = {};
        if (Array.isArray(data.studyProperties)) {
          data.studyProperties.forEach((item) => {
            const idx = item.indexOf(":");
            if (idx > -1) {
              const key = item.substring(0, idx).trim();
              const val = item.substring(idx + 1).trim();
              if (key) props[key] = val;
            }
          });
        }

        this.selectedStudyType = props["Study Type"] || "";
        this.enrolment = props["Estimated Enrollment"] || "";
        this.allocation = props["Allocation"] || "";
        this.intervention = props["Intervention Model"] || "";
        this.masking = props["Masking"] || "";
        this.purpose = props["Primary Purpose"] || "";
        this.title = props["Official Title"] || "";

        this.mapFromApiResponse(data);
      } catch (err) {
        console.error("Failed to retrieve study info:", err);
      }
    },

    async closeModal() {
      this.$emit("closeModal");
    },

    async addStudy() {
      if (this.selectedstudy == 0) {
        this.save();
      } else {
        this.edit();
      }
    },

    async clear() {
      this.values = {
        accountId: this.values.accountId,
        folderId: "string",
        studyName: "",
        sponsor: "",
        status: "",
        studyId: this.values.studyId,
        studyNotes: "",
        duration: 0,
        preVisit: 0,
        postVisit: 0,
        numberOfSite: 0,
        numberOfPatient: 0,
        active: false,
        isArmSpecific: false,
        isDeleted: false,
        studyProperties: [],
        oldVersion: "",
        newVersion: "",
        regulatoryRef: "",
        changeType: "",
        reasonForChange: "",
        reqReConsent: false
      };
      this.selectedStudyType = "";
      this.enrolment = "";
      this.allocation = "";
      this.intervention = "";
      this.masking = "";
      this.purpose = "";
      this.title = "";
      this.validations = [false, false];
      this.errors = [];
    }
  }
};
